export default {
  title: "Timeline",
  description: "Planifiez les moments clés de votre mariage",
  addEvent: "Ajouter un événement",
  noEvents: "Aucun événement",
  addFirstEvent: "Ajoutez votre premier événement",
  titlePlaceholder: "Nom de l'événement",
  descriptionPlaceholder: "Description de l'événement",
  durationLabel: "Durée",
  
  timelineWidget: {
    title: "Timeline",
    subtitle: "Prochains événements",
    empty: "Aucun événement à venir"
  },
  
  filters: {
    category: "Catégorie",
    date: "Date",
    search: "Rechercher un événement",
    clear: "Effacer les filtres",
    apply: "Appliquer",
    previous: "Précédent",
    next: "Suivant"
  },

  categories: {
    ceremony: "Cérémonie",
    reception: "Réception",
    photo: "Photos",
    preparation: "Préparation",
    task: "Tâche",
    vendor: "Prestataire",
    reminder: "Rappel",
    custom: "Personnalisé",
    other: "Autre",
    photos: "Photos",
    entertainment: "Animation",
    meal: "Repas",
    transportation: "Transport",
    select: "Sélectionner une catégorie",
    religious_venue: "Lieu de culte",
    city_hall: "Mairie",
    none: "Aucune"
  },

  status: {
    scheduled: "Prévu",
    confirmed: "Confirmé",
    completed: "Terminé",
    cancelled: "Annulé",
    delayed: "Retardé",
    in_progress: "En cours"
  },

  participants: "Participants",
  reminders: "Rappels",
  minutesAbbr: "min",
  duration: "Durée",

  errors: {
    noWeddingFound: "Aucun mariage trouvé",
    createWeddingFirst: "Veuillez d'abord créer un mariage",
    loadEvents: "Erreur lors du chargement des événements",
    addEvent: "Erreur lors de l'ajout de l'événement",
    updateEvent: "Erreur lors de la mise à jour de l'événement",
    deleteEvent: "Erreur lors de la suppression de l'événement",
    addExampleEvents: "Erreur lors de l'ajout des événements exemples"
  },

  actions: {
    addEvent: "Ajouter un événement",
    share: "Partager",
    useExample: "Utiliser un modèle",
    addExamples: "Ajouter des exemples",
    addingExamples: "Ajout des exemples en cours...",
  },

  empty: {
    title: "Aucun événement",
    description: "Commencez à planifier votre journée en ajoutant des événements."
  },

  delete: {
    title: "Supprimer l'événement",
    confirmation: "Êtes-vous sûr de vouloir supprimer cet événement ? Cette action est irréversible."
  },

  aria: {
    addEvent: "Ajouter un événement",
    edit: "Modifier l'événement",
    delete: "Supprimer l'événement"
  },

  examples: {
    preparation: {
      title: "Préparation",
      description: "Préparation des mariés et habillage"
    },
    ceremony: {
      title: "Cérémonie",
      description: "Cérémonie civile ou religieuse"
    },
    cocktail: {
      title: "Cocktail",
      description: "Vin d'honneur et photos"
    },
    lunch: {
      title: "Déjeuner / Dîner",
      description: "Repas de mariage"
    },
    speeches: {
      title: "Discours",
      description: "Discours des témoins et de la famille"
    },
    cake: {
      title: "Gâteau",
      description: "Découpe du gâteau et champagne"
    },
    party: {
      title: "Soirée",
      description: "Ouverture de bal et soirée dansante"
    },
    guestsArrival: {
      title: "Arrivée des invités",
      description: "Les invités commencent à arriver au lieu de réception"
    },
    dancing: {
      title: "Soirée dansante",
      description: "La piste de danse est ouverte"
    }
  },
  sharing: {
    recipientEmail: "Email du destinataire",
    emailPlaceholder: "exemple@email.com",
    recipientName: "Nom du destinataire",
    namePlaceholder: "Nom",
    message: "Message",
    messagePlaceholder: "Votre message...",
    send: "Envoyer",
    cancel: "Annuler",
    title: "Partager la timeline"
  },

  form: {
    title: "Détails de l'événement",
    name: "Nom",
    description: "Description",
    category: "Catégorie",
    startTime: "Heure de début",
    endTime: "Heure de fin",
    location: "Lieu",
    notes: "Notes",
    submit: "Enregistrer",
    cancel: "Annuler"
  },

  messages: {
    createSuccess: "Événement ajouté avec succès",
    updateSuccess: "Événement mis à jour avec succès",
    deleteSuccess: "Événement supprimé avec succès",
    deleteConfirm: "Êtes-vous sûr de vouloir supprimer cet événement ?",
    error: "Une erreur est survenue"
  },

  modal: {
    title: "Événement",
    edit: "Modifier l'événement",
    delete: "Supprimer l'événement",
    confirmDelete: "Êtes-vous sûr de vouloir supprimer cet événement ?"
  },

  view: {
    day: "Jour",
    week: "Semaine",
    month: "Mois",
    today: "Aujourd'hui",
    daysLeft: "{{count}} jours restants",
    upcoming: "À venir"
  }
} 